import {
  useV2CreateQuestionnaireLookupMutation,
  useV2UpdateQuestionnaireLookupMutation,
  useV2DeleteQuestionnaireLookupMutation,
} from "@generated";
import type { V2QuestionnaireLookupResource } from "@generated";
import type { LookupFormValues } from "../types";

export const buildLookupData = (
  values: LookupFormValues,
  id?: string
): V2QuestionnaireLookupResource => {
  const attributes: any = {
    name: values.name,
    "value-type": values.valueType,
    "index-1": values.index1,
    ...(values.index2 ? { "index-2": values.index2 } : {}),
    lookups: values.lookups,
  };
  return {
    type: "questionnaire-lookups",
    ...(id ? { id: Number(id) } : {}),
    attributes,
  } as unknown as V2QuestionnaireLookupResource;
};

export const useLookupMutations = (questionnaireId: string) => {
  const [create] = useV2CreateQuestionnaireLookupMutation();
  const [update] = useV2UpdateQuestionnaireLookupMutation();
  const [destroy] = useV2DeleteQuestionnaireLookupMutation();
  const qid = Number(questionnaireId);

  return {
    create: (values: LookupFormValues) =>
      create({
        questionnaireId: qid,
        body: { data: buildLookupData(values) },
      }).unwrap(),
    update: (id: string, values: LookupFormValues) =>
      update({
        questionnaireId: qid,
        id: Number(id),
        body: { data: buildLookupData(values, id) },
      }).unwrap(),
    remove: (id: string) =>
      destroy({ questionnaireId: qid, id: Number(id) }).unwrap(),
  };
};

export default useLookupMutations;
